import { Configuration } from './core/configuration/configuration';
import { Component, OnInit, ElementRef } from '@angular/core';
import dxDataGrid from 'devextreme/ui/data_grid';
import { Title } from '@angular/platform-browser';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(_title: Title) {
    _title.setTitle(Configuration.proyectName);
  }



  ngOnInit(): void {
    this.cargarConfiguracionGlobalDataGrid();
  }

  cargarConfiguracionGlobalDataGrid(): void {
    dxDataGrid.defaultOptions({
      options: {
        columnMinWidth: 25,
        columnHidingEnabled: true,
        columnAutoWidth: true,
        remoteOperations: false,
        rowAlternationEnabled: true,
        searchPanel: {
          visible: true,
          width: 400,
          placeholder: 'Buscar...'
        },
        headerFilter: {
          visible: true,
          width: 500,
          allowSearch: true
         },
        groupPanel: { visible: true },
        grouping: { autoExpandAll: false },
        scrolling: {
          showScrollbar: 'always'
        },
        pager: {
          showPageSizeSelector: true,
          showNavigationButtons: true,
          allowedPageSizes: [5, 8, 15, 30],
          showInfo: true
        },
        bindingOptions: {
          showColumnLines: true,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: false
        },
        paging: {
          pageSize: 8
        },
        height: '100%',
        loadPanel: { enabled: true },
        columnChooser: { enabled: true },
        allowColumnReordering: true,
        allowColumnResizing: true,
        editing: {
          texts: {
            confirmDeleteMessage: '' // Con ésto evitamos el mensaje de confirmación del dxDataGrid y gestionarlo nosotros.
          }
        },
      }
    });
  }
}
